(function() { window.GUID_8d147087_1fcf_4fad_b637_380fa8d6128a = { getGuid: function() { return "8d147087-1fcf-4fad-b637-380fa8d6128a"; } }; })();
var CS;
(function (CS) {
    /**
     * Return a string for the selected User Langue
     * @param English
     * Default string returned if no match
     * @param French
     * French string
     * @param Spanish
     * Spanish string (Espagnol)
     */
    CS.Lang = (English, French, Spanish) => {
        var _a, _b;
        var lang = (_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en";
        switch (lang) {
            case "fr":
                if (French)
                    return French;
                break;
            case "es":
                if (Spanish)
                    return Spanish;
                break;
            default:
        }
        return English; //To Check how to do it
    };
    CS.Ress = (params) => {
        var _a, _b;
        const { english, french, spanish } = params;
        var lang = (_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en";
        switch (lang) {
            case "fr":
                if (french)
                    return french;
                break;
            case "es":
                if (spanish)
                    return spanish;
                break;
            default:
        }
        return english;
    };
})(CS || (CS = {}));

//# sourceMappingURL=cs-lang.js.map
